var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VuePellEditor',{attrs:{"value":_vm.value,"actions":_vm.actions,"content":_vm.value,"placeholder":_vm.placeholder,"style-with-css":false,"classes":_vm.editorClasses,"default-paragraph-separator":""},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }